/* ============================================================
   Feature Highlights — section-feature-highlights.js
   Handles scroll-in animation only. No deps.
   ============================================================ */
(function () {
  'use strict';

  const SELECTOR = '[data-feature-highlights]';
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setupAnimation(el) {
    const animation = el.dataset.animation;
    if (!animation || animation === 'none' || prefersReduced) {
      // No animation requested — make items immediately visible
      el.classList.add('is-in-view');
      return;
    }

    // Apply stagger delay as a CSS custom property
    const stagger = parseInt(el.dataset.stagger, 10);
    if (!isNaN(stagger)) {
      el.style.setProperty('--fh-anim-stagger', stagger + 'ms');
    }

    if (!('IntersectionObserver' in window)) {
      // Fallback for very old browsers
      el.classList.add('is-in-view');
      return;
    }

    const io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    io.observe(el);
    el.__fhObserver = io;
  }

  function initAll(scope) {
    const root = scope || document;
    root.querySelectorAll(SELECTOR).forEach(function (el) {
      if (!el.__fhInitialized) {
        el.__fhInitialized = true;
        setupAnimation(el);
      }
    });
  }

  function destroy(el) {
    if (el && el.__fhObserver) {
      el.__fhObserver.disconnect();
      el.__fhObserver = null;
      el.__fhInitialized = false;
    }
  }

  /* ---------- Boot ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* ---------- Shopify Theme Editor ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    const el = e.target.querySelector(SELECTOR);
    if (el) destroy(el);
  });

  // Re-trigger animation when previewing changes in the editor
  document.addEventListener('shopify:section:select', function (e) {
    const el = e.target.querySelector(SELECTOR);
    if (el) el.classList.add('is-in-view');
  });

  document.addEventListener('shopify:block:select', function (e) {
    const el = e.target.closest(SELECTOR);
    if (el) el.classList.add('is-in-view');
  });
})();
